module.exports = __webpack_public_path__ + "static/media/icomoon.60251811.svg";